module.exports = __webpack_public_path__ + "static/slider01.e139a1fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/slider/slider01.jpg
// module id = 472
// module chunks = 263791100135453